/* PWW v78: collection search, tire season filtering, and homepage carousel controls. */
(function () {
  function qs(root, selector) {
    return root.querySelector(selector);
  }

  function withParam(url, name, value) {
    if (!value) return url;
    var separator = url.indexOf('?') === -1 ? '?' : '&';
    return url + separator + encodeURIComponent(name) + '=' + encodeURIComponent(value);
  }

  function normalize(value) {
    return String(value || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').replace(/\s+/g, ' ').trim();
  }

  function seasonValue(value) {
    var normalized = normalize(value);
    if (!normalized) return '';
    if (normalized.indexOf('all weather') !== -1 || normalized.indexOf('allweather') !== -1) return 'all weather';
    if (normalized.indexOf('all season') !== -1 || normalized.indexOf('allseason') !== -1) return 'all season';
    if (normalized.indexOf('winter') !== -1 || normalized.indexOf('snow') !== -1 || normalized.indexOf('ice') !== -1) return 'winter';
    if (normalized.indexOf('summer') !== -1 || normalized.indexOf('performance') !== -1) return 'summer';
    return '';
  }

  function cardSeason(item) {
    var title = item.dataset.pwwProductTitle || '';
    var link = item.querySelector('.card__heading a, .full-unstyled-link');
    if (!title && link) title = link.textContent;
    var titleSeason = seasonValue(title);
    if (titleSeason && titleSeason !== 'all season') return titleSeason;

    var metafieldSeason = seasonValue(item.dataset.pwwTireSeason);
    if (metafieldSeason) return metafieldSeason;
    return titleSeason;
  }

  function activeSeasonFilter() {
    var params = new URLSearchParams(window.location.search);
    return seasonValue(params.get('filter.p.m.custom.tire_season'));
  }

  function applyTireSeasonFilter() {
    var wantedSeason = activeSeasonFilter();
    var grid = document.querySelector('#product-grid, .product-grid');
    if (!wantedSeason || !grid) return;

    var hiddenCount = 0;
    grid.querySelectorAll(':scope > .grid__item').forEach(function (item) {
      var itemSeason = cardSeason(item);
      var isMismatch = itemSeason && itemSeason !== wantedSeason;
      item.hidden = isMismatch || item.classList.contains('pww-fitment-duplicate-hidden');
      item.classList.toggle('pww-season-filter-hidden', isMismatch);
      if (isMismatch) hiddenCount += 1;
    });

    document.querySelectorAll('[data-pww-season-chip]').forEach(function (chip) {
      chip.classList.toggle('is-active', seasonValue(chip.dataset.pwwSeasonChip) === wantedSeason);
    });

    if (hiddenCount) {
      grid.dataset.pwwSeasonFilterApplied = wantedSeason;
    }
  }

  function initSearchBox(box) {
    if (!box || box.dataset.pwwCollectionSearchReady === 'true') return;
    box.dataset.pwwCollectionSearchReady = 'true';

    function activateTab(target) {
      box.querySelectorAll('[data-pww-search-tab]').forEach(function (button) {
        button.classList.toggle('is-active', button.dataset.pwwSearchTab === target);
      });
      box.querySelectorAll('[data-pww-search-panel]').forEach(function (panel) {
        panel.classList.toggle('is-active', panel.dataset.pwwSearchPanel === target);
      });
    }

    box.querySelectorAll('[data-pww-search-tab]').forEach(function (tab) {
      tab.addEventListener('click', function () {
        activateTab(tab.dataset.pwwSearchTab);
      });
    });

    if (window.location.pathname.toLowerCase().indexOf('tire') !== -1) activateTab('tire');

    qs(box, '[data-pww-wheel-search]').addEventListener('click', function () {
      var diameter = qs(box, '[data-pww-wheel-diameter]').value;
      var bolt = qs(box, '[data-pww-wheel-bolt]').value;
      var url = diameter ? '/collections/' + diameter + '-wheel' : '/pages/wheels';
      url = withParam(url, 'sort_by', 'price-ascending');
      url = withParam(url, 'filter.p.m.custom.wheel_bolt_pattern', bolt);
      window.location.href = url;
    });

    qs(box, '[data-pww-tire-search]').addEventListener('click', function () {
      var diameter = qs(box, '[data-pww-tire-diameter]').value;
      var width = qs(box, '[data-pww-tire-width]').value;
      var url = diameter ? '/collections/' + diameter + '-tire' : '/search?q=Tires';
      url = withParam(url, 'sort_by', 'price-ascending');
      url = withParam(url, 'filter.p.m.custom.tire_width', width);
      window.location.href = url;
    });
  }

  function initFeaturedCarousels() {
    document.querySelectorAll('[data-pww-featured-carousel]').forEach(function (carousel) {
      if (carousel.dataset.pwwCarouselReady === 'true') return;
      carousel.dataset.pwwCarouselReady = 'true';
      var track = carousel.querySelector('[data-pww-carousel-track]');
      if (!track) return;

      function scrollByCard(direction) {
        var card = track.querySelector('.pww-featured-wheel-card');
        var amount = card ? card.getBoundingClientRect().width + 16 : 260;
        track.scrollBy({ left: amount * direction, behavior: 'smooth' });
      }

      var prev = carousel.querySelector('[data-pww-carousel-prev]');
      var next = carousel.querySelector('[data-pww-carousel-next]');
      if (prev) prev.addEventListener('click', function () { scrollByCard(-1); });
      if (next) next.addEventListener('click', function () { scrollByCard(1); });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-pww-collection-search]').forEach(initSearchBox);
    initFeaturedCarousels();
    applyTireSeasonFilter();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('facet:updated', applyTireSeasonFilter);
})();
